import http from './http'

const basePath = '/Telas/Obrigacao'

export default {
  async getPaged (params) {
    const response = await http.get(`${basePath}/GetPaged`, { params })
    return response.data
  },
  async getById (id) {
    const response = await http.get(`${basePath}/GetById/${id}`)
    return response.data
  },
  async getOptions () {
    const response = await http.get(`${basePath}/GetOptions`)
    return response.data
  },
  async add (input) {
    const response = await http.post(`${basePath}/Add`, input)
    return response.data
  },
  async update (input) {
    await http.put(`${basePath}/Update`, input)
  },
  async getAttachmentConfiguration () {
    const response = await http.get(`${basePath}/GetAttachmentConfiguration`)
    return response.data
  },
  async getAttachments (documentId) {
    const response = await http.get(`${basePath}/GetAttachments/${documentId}`)
    return response.data
  },
  async addAttachment (documentId, file, description) {
    const formData = new FormData()
    formData.append('file', file)
    if (description) formData.append('description', description)
    const response = await http.post(`${basePath}/AddAttachment/${documentId}`, formData)
    return response.data
  },
  async downloadAttachment (documentId, attachmentId) {
    const response = await http.get(`${basePath}/DownloadAttachment/${documentId}/${attachmentId}`, { responseType: 'blob' })
    return response.data
  },
  async inactivateAttachment (documentId, attachmentId) {
    await http.delete(`${basePath}/InactivateAttachment/${documentId}/${attachmentId}`)
  }
}
